import React, { useState } from "react";
import { X, Tag, ExternalLink } from "lucide-react";

/**
 * TrekExpertPromoBanner (iter170) — slim high-contrast strip pinned to
 * the very top of the homepage advertising the current ADI10 offer on
 * Trek Expert. Uses the app's own affiliate redirector so clicks route
 * through the operator's AWIN publisher ID (2895407) with a `clickref`
 * of `ADI10` for attribution in the AWIN dashboard.
 *
 * Once the operator dismisses it or the promo ends, they can set
 * `localStorage.ccu:trek-adi10:hidden=1` (or update this component's
 * enabled flag) to silence it forever.
 */
const HIDE_KEY = "ccu:trek-adi10:hidden";

export default function TrekExpertPromoBanner() {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(HIDE_KEY) === "1"; } catch { return false; }
  });
  if (hidden) return null;

  const dismiss = () => {
    try { localStorage.setItem(HIDE_KEY, "1"); } catch { /* ignore */ }
    setHidden(true);
  };

  // App's affiliate redirector — falls back to the merchant's root URL
  // if the merchant ID is not yet configured (302 pass-through until
  // AWIN emails the mid and it's set via /admin).
  const href = "/api/r/trek-expert?clickref=ADI10";

  return (
    <div
      className="w-full bg-[#0e0e0e] text-white"
      data-testid="trek-expert-promo-banner"
      role="region"
      aria-label="Trek Expert Adidas promotion"
    >
      <div className="max-w-[1400px] mx-auto px-3 sm:px-6 lg:px-10 py-2 flex items-center gap-3">
        <span className="inline-flex items-center gap-1.5 bg-[#ff4500] text-white px-2 py-0.5 text-[10px] mono uppercase tracking-widest font-black shrink-0">
          <Tag className="w-3 h-3" /> Live offer
        </span>
        <a
          href={href}
          target="_blank"
          rel="sponsored noopener noreferrer"
          className="flex-1 min-w-0 text-[12px] sm:text-sm leading-tight hover:underline"
          data-testid="trek-expert-promo-link"
        >
          <span className="font-bold">Extra 10% off adidas Terrex</span>
          <span className="hidden sm:inline text-white/80">
            {" "}— hiking, trail running &amp; outdoor gear at Trek Expert.
          </span>
          <span className="ml-1.5 inline-flex items-center gap-1 border border-white/40 px-1.5 py-0.5 text-[10px] mono uppercase tracking-widest">
            Code: ADI10 <ExternalLink className="w-3 h-3" />
          </span>
        </a>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss promotion"
          className="shrink-0 text-white/70 hover:text-white p-1"
          data-testid="trek-expert-promo-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
